import React from 'react';
import { Card, CardContent, TextField, Grid, Typography, Button, Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import SendIcon from '@mui/icons-material/Send';
import { PRIMARY } from 'themes/colors';
import SmsIcon from '@mui/icons-material/Sms';

interface ISMSData {
  agent: string;
  load: number;
  regulator: number;
  pipe: number;
  light: number;
  bplOven: number;
  nonHpOven: number;
  hpOven: number;
  installationPending: number;
  paidAmount: number;
  dueAmount: number;
}

interface SMSUpdateProps {
  agent: { agent: string };
  sms: ISMSData;
  handleChangeSMS: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sendSms: () => void;
}

export const SMSUpdate: React.FC<SMSUpdateProps> = ({ agent, sms, handleChangeSMS, sendSms }) => {
  type FieldConfig = { name: keyof ISMSData; label: string };

  const leftColumnFields: FieldConfig[] = [
    { name: 'load', label: 'Load' },
    { name: 'regulator', label: 'Regulator' },
    { name: 'hpOven', label: 'HP Oven' },
    { name: 'bplOven', label: 'BPL Oven' },
    { name: 'paidAmount', label: 'Amount Paid' },
  ];

  const rightColumnFields: FieldConfig[] = [
    { name: 'pipe', label: 'Pipe' },
    { name: 'nonHpOven', label: 'Non HP Oven' },
    { name: 'light', label: 'Light' },
    { name: 'installationPending', label: 'Installation Pending' },
    { name: 'dueAmount', label: 'Total Amount Due' },
  ];

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'grey.200',
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 2.5, py: 2,
          bgcolor: alpha(PRIMARY.main, 0.04),
          borderBottom: '1px solid', borderColor: 'grey.200',
          display: 'flex', alignItems: 'center', gap: 1.5,
        }}
      >
        <Box
          sx={{
            width: 36, height: 36, borderRadius: 2,
            bgcolor: alpha(PRIMARY.main, 0.1),
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <SmsIcon sx={{ color: PRIMARY.main, fontSize: 18 }} />
        </Box>
        <Box>
          <Typography variant="subtitle2" fontWeight={700}>Send SMS Update</Typography>
          <Typography variant="caption" color="text.secondary">
            To:{' '}
            <span style={{ color: '#e91e63', fontWeight: 600 }}>{agent.agent}</span>
          </Typography>
        </Box>
      </Box>

      <CardContent sx={{ p: 2.5, flex: 1 }}>
        <Grid container spacing={1.5}>
          <Grid item xs={6}>
            {leftColumnFields.map((field) => (
              <TextField
                key={field.name}
                label={field.label}
                size="small"
                value={sms[field.name]}
                onChange={handleChangeSMS}
                name={field.name}
                type="number"
                fullWidth
                margin="dense"
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            ))}
          </Grid>
          <Grid item xs={6}>
            {rightColumnFields.map((field) => (
              <TextField
                key={field.name}
                label={field.label}
                size="small"
                value={sms[field.name]}
                onChange={handleChangeSMS}
                name={field.name}
                type="number"
                fullWidth
                margin="dense"
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            ))}
          </Grid>
        </Grid>
      </CardContent>

      <Box sx={{ px: 2.5, pb: 2.5 }}>
        <Button
          variant="contained"
          onClick={sendSms}
          fullWidth
          startIcon={<SendIcon />}
          sx={{
            borderRadius: 2, py: 1.2,
            background: `linear-gradient(135deg, ${PRIMARY.darker}, ${PRIMARY.main})`,
            boxShadow: '0 4px 12px rgba(13,154,79,0.3)',
            fontWeight: 600,
            '&:hover': { background: `linear-gradient(135deg, ${PRIMARY.dark}, ${PRIMARY.main})` },
          }}
        >
          Send SMS
        </Button>
      </Box>
    </Card>
  );
};
